import Axios from 'axios';
import EVENT from './event-bus/event';

const REQ_TIMEOUT = 30 * 1000;

const http = Axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    // 'Access-Control-Allow-Origin': '*',
  },
  timeout: REQ_TIMEOUT,
  withCredentials: true,
  maxBodyLength: Infinity,
});

http.interceptors.request.use(async (request) => {
  return request;
});

/**
 * intercepts any response and checks the response from our api for a 401 status in the response. ie. the token has now expired and is no longer valid, or no valid token was sent.
 * If such a status exists then we log out the user and clear the profile from redux state.
 */
http.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalRequest = err.config;

    // Bắt lỗi 401 (Unauthorized) và đảm bảo chưa gọi lại lần nào
    if (err.response?.status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true;
      const requestUrl = originalRequest.url || '';
      if (!requestUrl.includes('/auth/refresh')) {
        try {
          await http.post('/auth/refresh');
          return await http(originalRequest);
        } catch (refreshErr) {
          EVENT.onError(refreshErr);
          return Promise.reject(refreshErr);
        }
      }
      EVENT.onError(err);
      return Promise.reject(err);
    }

    EVENT.onError(err);

    return Promise.reject(err);
  },
);

export default http;
